import allImgPaths from 'assets/images'
import useAppState from 'context/useAppState';
import useVendorHook from 'hooks/vendor/useVendor';
import { cloneDeep } from 'lodash'
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getVendorInfo, updateVendorInfo } from 'services/vendor';

const onBoardingImages = [
    { imgUrl: allImgPaths.vcAccomodation, name: 'Accommodation', selected: true },
    { imgUrl: allImgPaths.vcActivity, name: 'Activity & Experiences', selected: false },
    { imgUrl: allImgPaths.vcDecore, name: 'Decor', selected: false },
    { imgUrl: allImgPaths.vcEntertaintment, name: 'Entertainment', selected: false },
    { imgUrl: allImgPaths.vcEventVenue, name: 'Event Venue', selected: false },
    { imgUrl: allImgPaths.vcFoodBeverage, name: 'Food & Beverage', selected: false },
    { imgUrl: allImgPaths.vcGifting, name: 'Gifting', selected: false },
    { imgUrl: allImgPaths.vcMarketing, name: 'Marketing & Promotion', selected: false },
    { imgUrl: allImgPaths.vcSecurity, name: 'Security & Staffing', selected: false },
    { imgUrl: allImgPaths.vcTech, name: 'Technology Partner', selected: false },
    { imgUrl: allImgPaths.vcTransportation, name: 'Transportation', selected: false },
    { imgUrl: allImgPaths.vcOthers, name: 'Others', selected: false },
]

const Onboarding1 = () => {
    const navigate = useNavigate();
    const { setState: setVendorState, callVendorDataAPI, fetchVendorData, vendorData } = useAppState('vendorHook')
    const [allCategories, setAllCategories] = useState<any>(onBoardingImages)

    console.log({ ob1: vendorData })

    useEffect(() => {
        if (callVendorDataAPI) {
            fetchVendorData()
        }
    }, [callVendorDataAPI])

    useEffect(() => {
        setVendorInfo()
    }, [vendorData])

    const setVendorInfo = () => {
        if (vendorData?.categories?.length) {
            const clonedCategories = cloneDeep(allCategories);

            clonedCategories.map((item: any) => {
                item.selected = vendorData.categories.includes(item.name); // Assuming 'name' holds category value
            });

            setAllCategories(clonedCategories);
        }
    }

    const handleSelection = (index: number) => {
        const clonedCategories = cloneDeep(allCategories);
        clonedCategories.map((item: any, i: any) => {
            item.selected = i === index;
        });
        setAllCategories(clonedCategories)
    }

    const handleUpdate = async () => {
        const categories = allCategories.filter((c: any) => c.selected).map((c: any) => c.name)
        const payload = {
            data: { categories }
        }

        try {
            await updateVendorInfo(payload);

            let clonedVendorData = cloneDeep(vendorData);
            clonedVendorData = { ...clonedVendorData, ...payload.data }
            setVendorState({ vendorData: clonedVendorData })

            navigate("/vendor/onboarding2");
        } catch (error) {
            console.log({ error })
        }
    }

    return (
        <div className="flex justify-center items-center h-screen">
            <div className="w-full max-w-[665px] mx-auto">
                <div className="pb-8">
                    <img className="block w-[220px] mx-auto" src={allImgPaths.mainLogo} alt="" />
                    <h2 className='text-4xl text-[#475467] font-interSemiBold text-center my-8'>
                        <span className='text-4xl text-[#101828] font-interSemiBold'>Welcome! </span>
                        Let’s get started!
                    </h2>
                    <div className="text-center">
                        <p className='text-base text-[#101828] font-interSemiBold pb-0.5'>Select a category that best describes your offering: </p>
                        <p className='text-sm text-[#475467]'>If you offer multiple services, don’t worry you can tell us about it in the next steps.</p>
                    </div>
                </div>
                <div className="">
                    <div className="flex gap-4 flex-wrap mb-10">
                        {
                            allCategories.map((item: any, idx: any) => {
                                return (
                                    <div key={idx} onClick={() => { handleSelection(idx) }}
                                        className={`p-1 rounded-md border border-[#EAECF0] hover:shadow-xl cursor-pointer ${item.selected ? "shadow-xl" : ""}`}>
                                        <div className="rounded-t-md relative">
                                            <img className='rounded-t-md h-16 w-36 object-cover' src={item.imgUrl} alt="" />
                                            {
                                                item.selected &&
                                                <img className='absolute z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' src={allImgPaths.vendorRightCheckIcon} alt="" />
                                            }
                                        </div>
                                        <div className="bg-[#F2F4F7] rounded-b-md flex items-center justify-center mt-2">
                                            <span className='text-xs font-interMedium text-[#344054] py-1'>{item.name}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>

                <div className="flex justify-end">
                    <button
                        className="submit-btn-blue blue-btn-hover flex gap-x-1.5 items-center !pl-4 !pr-2"
                        type="button"
                        onClick={handleUpdate}
                    >
                        Next
                        <img className='w-[22px] h-[22px]' src={allImgPaths.rightArrow} alt="" />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Onboarding1